import { FC } from "react";
import { IconPropsType } from ".";

export const Person: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12C2.7 12 0 9.3 0 6C0 2.7 2.7 0 6 0C9.3 0 12 2.7 12 6C12 9.3 9.3 12 6 12ZM6 1.5C3.49988 1.5 1.5 3.49988 1.5 6C1.5 8.50012 3.49988 10.5 6 10.5C8.50012 10.5 10.5 8.50012 10.5 6C10.5 3.49988 8.50012 1.5 6 1.5Z"
        fill={props.color}
      />
      <path
        d="M7.5 4.5C7.5 5.32838 6.82838 6 6 6C5.17162 6 4.5 5.32838 4.5 4.5C4.5 3.67162 5.17162 3 6 3C6.82838 3 7.5 3.67162 7.5 4.5Z"
        fill={props.color}
      />
      <path
        d="M6.25013 7.00013C7.85025 7.00013 9.25013 8.00025 9.80025 9.50025C7.10025 12.8003 2.55038 10.2004 2.65013 9.75038C3.05025 8.15025 4.55025 7.0005 6.25013 7.0005V7.00013Z"
        fill={props.color}
      />
    </svg>
  );
};
